import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createAppeal,
  deleteAppealById,
  getAppealById,
  getAppealList,
  updateAppealById,
} from "./queries";

const AppealContext = createContext({});

export const useAppealContext = () => useContext(AppealContext);

export const AppealProvider = ({ ...props }) => {
  const [appealList, setAppealList] = useState([]);
  const [appealPerId, setAppealPerId] = useState({});

  const appealListGetter = useCallback(async () => {
    try {
      if (appealList.length === 0) {
        setAppealList(await getAppealList());
      }
    } catch (e) {
      console.error("appealListGetter", e);
      throw e;
    }
  }, [appealList]);
  const appealByIdGetter = useCallback(
    async (id) => {
      try {
        setAppealPerId(await getAppealById(id));
      } catch (e) {
        console.error("appealListGetter", e);
        throw e;
      }
    },
    [setAppealPerId]
  );
  const appealCreate = useCallback(async (data) => {
    try {
      const appeal = await createAppeal(data);
      setAppealList((old) => [...old, appeal]);
    } catch (e) {
      console.error("appealCreate", e);
      throw e;
    }
  }, []);
  const appealUpdateById = useCallback(async (id, data) => {
    try {
      const updatedAppeal = await updateAppealById(id, data);
      setAppealPerId(updatedAppeal);
      setAppealList((old) =>
        old.map((elm) => (elm.id === updatedAppeal.id ? updatedAppeal : elm))
      );
    } catch (e) {
      console.error("appealUpdateById", e);
      throw e;
    }
  }, []);

  const appealDeleteById = useCallback(
    async (id) => {
      try {
        await deleteAppealById(id);
        setAppealList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("appealDelete", e);
        throw e;
      }
    },
    [setAppealList]
  );
  const values = useMemo(
    () => ({
      appealList,
      appealListGetter,
      appealByIdGetter,
      appealDeleteById,
      appealCreate,
      appealUpdateById,
      appealPerId,
      setAppealPerId,
    }),
    [
      appealList,
      appealListGetter,
      appealByIdGetter,
      appealDeleteById,
      appealCreate,
      appealUpdateById,
      appealPerId,
      setAppealPerId,
    ]
  );
  return <AppealContext.Provider value={values} {...props} />;
};
